module.exports = "<sa-header></sa-header>\r\n\r\n<sa-navigation></sa-navigation>\r\n\r\n<div id=\"main\" role=\"main\">\r\n  <script type=\"text/javascript\" src=\"{{localStorage.getItem('impinj-url')}}/hubs\"></script>\r\n\r\n  <!-- Ezio: removed demo cog -->\r\n  <!-- <sa-layout-switcher></sa-layout-switcher> -->\r\n\r\n  <sa-ribbon></sa-ribbon>\r\n  <router-outlet></router-outlet>\r\n</div>\r\n\r\n<!-- <sa-footer></sa-footer> -->\r\n\r\n  <!-- Ezio: removed demo shortcuts (bar of icons on top) -->\r\n<!-- <sa-shortcut></sa-shortcut> -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/layout/app-layouts/main-layout.component.html
// module id = 870
// module chunks = 29